import MessageIcon from '@mui/icons-material/Message';
import { IconButton } from "@mui/material";
import { useRouter } from "next/navigation";
export function IMOpenPageLink(){
    const router = useRouter();
    function onClick(){
        router.push('/im')
    }
    return (
        <span>
            <IconButton onClick={onClick}>
                <MessageIcon />
                {/* {t('PageLinks.im')} */}
            </IconButton>
        </span>
    )
}